import React from "react";

// styles
import styles from "./styles.module.scss";

const Divider = () => {
  return (
    <div className={styles.divider}>
      <div></div>
      <span>OR</span>
      <div></div>
    </div>
  );
};

export default Divider;
